import { Box, Flex, Text } from '@chakra-ui/react';

import { ClockIcon, LightningIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

const FLASH_SALE_EYEBROW_LABEL = 'FLASH SALE';
const DEFAULT_FLASH_SALE_EYEBROW_COLOR = '#AFC6FF';

export type FlashSaleEyebrowSize = 'default' | 'compact';
export type FlashSaleEyebrowIcon = 'clock' | 'lightning';

/**
 * Shared flash-sale eyebrow row: icon + uppercase condensed label + thin divider.
 * Used by flash-sale homepage and catalog surfaces.
 */
export function FlashSaleEyebrow({
  color = DEFAULT_FLASH_SALE_EYEBROW_COLOR,
  dividerGradient,
  icon = 'lightning',
  label = FLASH_SALE_EYEBROW_LABEL,
  size = 'default',
}: {
  color?: string;
  /** Chakra `bgGradient` for the divider; defaults to a solid `color` line. */
  dividerGradient?: string;
  icon?: FlashSaleEyebrowIcon;
  label?: string;
  size?: FlashSaleEyebrowSize;
}) {
  const isCompact = size === 'compact';
  const iconSize = isCompact ? '14px' : '16px';

  return (
    <Flex alignItems='center' gap={isCompact ? 2 : 4} width='100%'>
      <Flex alignItems='center' color={color} flexShrink={0} gap={2}>
        {icon === 'clock' ? (
          <ClockIcon boxSize={iconSize} aria-hidden />
        ) : (
          <LightningIcon height={iconSize} width={iconSize} />
        )}
        <Text
          fontFamily='condensed'
          fontSize={isCompact ? '12px' : '0.9375rem'}
          fontWeight='500'
          letterSpacing={isCompact ? '0.1em' : '0.06em'}
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {label}
        </Text>
      </Flex>
      <Box
        backgroundColor={dividerGradient ? undefined : color}
        bgGradient={dividerGradient}
        flex={1}
        height='1px'
        minWidth={0}
        opacity={0.6}
      />
    </Flex>
  );
}
